import React, { useEffect, useState } from 'react'
import Seo from './Seo'
import { Container, Row, Col } from 'reactstrap'
import Contact from './conatct'
import HeaderRightIMG from '../assets/images/01-Compliance-.png'
import Deepesh from '../assets/images/Thumnails/Deepesh-Rastogi.png'
import Hemant from '../assets/images/Thumnails/Hemant-Chadha.png'
import Vishal from '../assets/images/Thumnails/Vishal-Bansal.png'
import Footer from './footer'
import linKEDIcon from '../assets/images/LinkedIn.svg'
import { ScrollEffect } from 'react-easy-scroll-effect'
import 'react-easy-scroll-effect/dist/index.css'
import PHImg from '../assets/images/Banner/Leadership.png'
import { Link } from 'react-router-dom'

export default function MeetExpert() {
    useEffect(()=>{
        window.scrollTo(0, 0);
        document.title = 'Leadership Team | Agilus Technologies'
    }, [])

  return (
    <>
      <Seo
        title="Leadership & Experts"
        description="Meet the leadership and experts behind Agilus Technologies driving innovation in IT infrastructure management."
        path="/meet-expert"
      />
     {/* hero section */}

        <section className='custom-margin-for-header'>
            <img src={PHImg} className='img-fluid'/>
        </section>
        {/* hero section */}
        <section className='ce-hero-section py-5'>
            {/* <ScrollEffect id='1'> */}
            <Container >
                <Row>
                    <Col sm={12} className='text-center mb-3'><h1 className='fw-normal font-50 archivo-medium'>Leadership Team</h1></Col>
                <Col sm={12} className='align-content'>
                    
                    <p className='mb-3 text-center inter-normal'>At Agilus, our seasoned leaders drive innovation and growth, inspiring excellence and empowering teams to deliver extraordinary results.</p>
                    
                </Col>
                
               
                </Row>
            </Container>
            {/* </ScrollEffect> */}

        </section>
        {/* <div className='pb-5'></div> */}

        {/* expert */}
        <section className='agilus-expert px-3'>
        <div className={`bg-light-green p-5 custom-rounded`}>
        <ScrollEffect id='2'>
            <Container>
            

            <Row>
                      <Col col={12} md={6} lg={4} xl={4} xxl={4} className='mb-2'>
                      <div className='bg-white custom-rounded'>
                          <div className='blog-item blog-item-one custom-rounded'>
                              <div className='img-box'>
                                  <img src={Hemant} className='img-fluid' />
                                 
                              </div>
                              <div className='detail-box'>
                                  <p className='mb-2'>Head of Technology at Velocis Systems and Agilus, Hemant brings 34 years of extensive experience in delivering technology solutions. He leads pan-India presales team, focusing on implementing innovative IT solutions and leveraging automation to enhance operational efficiencies. He has been instrumental in implementing advanced technologies and strategies, addressing complex challenges, and consistently ensuring the successful delivery of customer commitments while promoting a results-driven approach within the team.</p>
                              </div>
 
                             
                          </div>
                          <div className='p-3 pt-1'>
                              <h2 className='font-24 fw-normal archivo-medium mt-1 lh-15 mb-0'>Hemant Chadha</h2>
                                  <span className='agilus-expert-item-degignation'>Associate Director & CTO</span>
                                  <br />
                                  <a href='https://www.linkedin.com/in/hemant-chadha-90469b15?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#0077b7" class="bi bi-linkedin" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"></path></svg>
                                  </a>
                              </div>
                          </div>
                      </Col>
                      <Col col={12} md={6} lg={4} xl={4} xxl={4} className='mb-2'>
                      <div className='bg-white custom-rounded'>
                          <div className='blog-item blog-item-two custom-rounded'>
                              <div className='img-box'>
                                  <img src={Deepesh} className='img-fluid' />
                                 
                              </div>
                             
                              <div className='detail-box'>
                                  <p className='mb-2'>Deepesh brings over 23 years of IT industry expertise and a decade in senior leadership roles, driving strategic business development, revenue growth, and impactful client solutions. As a business leader, he aligns organizational goals with Agilus’ transformative vision, leading revenue-centric strategies, market expansion, and customer retention initiatives.</p>
                                  <p className='mb-2'>In his role, Deepesh is responsible for building and executing high-impact sales strategies that ensure sustainable growth and market relevance. He oversees lead generation, client acquisition, account management, and campaign ROI, with end-to-end P&L accountability. By balancing cost efficiency with operational excellence, he optimizes profitability and aligns team performance with organizational goals.</p>
                                  <p className='mb-2'>A collaborative and results-driven leader, Deepesh is committed to building strong client partnerships and delivering solutions that meet evolving client needs. His strategic direction fosters a culture of service excellence and adaptability, further enhancing Agilus’ competitive position in the industry.</p>
                              </div>
                          </div>
                          <div className='p-3 pt-1'>
                          <h2 className='font-24 fw-normal archivo-medium mt-1 lh-15 mb-0'>Deepesh Rastogi</h2>
                                  <span className='agilus-expert-item-degignation'>SVP and Chief Sales & Marketing Officer</span>
                                  <br />
                                  <a href='https://www.linkedin.com/in/deepeshr?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#0077b7" class="bi bi-linkedin" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"></path></svg>
                                  </a>
                                  </div>
                                  </div>
                         
                      </Col>
                      <Col sm={4}>
                      <div className='bg-white custom-rounded'>
                          <div className='blog-item blog-item-three custom-rounded'>
                              <div className='img-box'>
                                  <img src={Vishal} className='img-fluid' />
                                 
                              </div>
                              <div className='detail-box'>
                                  <p className='mb-2'>Vishal Bansal serves as the Associate Vice President at Agilus Technologies, bringing 8 years of expertise in designing and implementing advanced systems that enhance connectivity, scalability, and security across complex digital infrastructures. With a strong educational background as a Data Analyst and Tech Graduate, Vishal combines analytical insight with technical expertise to drive innovation in solution design and seamless integration.</p>
                                  <p className='mb-2'>In his role, Vishal leads product development for Agilus’s IT management solutions, ensuring they empower clients to streamline operations, drive cost efficiency, and maintain regulatory compliance. His deep expertise in integrating complex infrastructures allows him to craft secure, adaptable solutions designed to meet diverse client needs. Working closely with his engineering team, Vishal fosters a culture of innovation and continuous improvement, delivering products that remain resilient, future-ready, and responsive to a rapidly evolving IT landscape.</p>
                                  <p className='mb-2'>Vishal envisions unlocking the full potential of IT for Agilus Technologies’ clients, positioning the company as a trusted partner for organizations seeking adaptive, innovative, and integrated IT management solutions. His dedication to digital resilience and operational excellence empowers Agilus to help clients navigate complex challenges, delivering solutions that meet immediate needs while paving the way for future growth.</p>
                              </div>
                          </div>
                          <div className='p-3 pt-1'>
                          <h2 className='font-24 fw-normal archivo-medium mt-1 lh-15 mb-0'>Vishal Bansal</h2>
                                  <span className='agilus-expert-item-degignation'>Associate Vice President</span>
                                  <br />
                                  <a href=' https://www.linkedin.com/in/vishal-bansal-5a20757a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#0077b7" class="bi bi-linkedin" viewBox="0 0 16 16"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"></path></svg>
                                  </a>
                          </div>
                          </div>
                      </Col>
                  </Row>

            
            
            </Container>
            </ScrollEffect>
            </div>
        </section>
        <div className='pb-5'></div>

         {/* contact */}
         <ScrollEffect id='3'>
         <Contact />
         </ScrollEffect>


{/* footer */}
<ScrollEffect id='4'>
<Footer />
</ScrollEffect>
    </>
  )
}
